export const textStyles = {
  hx: {
    sizeMultiplier: 2.4,
    weight: 700,
    size: 56,
    lineHeight: 1.5,
    letterSpacing: -0.48,
  },
  h0: {
    sizeMultiplier: 2,
    weight: 800,
    size: 40,
    lineHeight: 1.5,
    letterSpacing: -0.48,
  },
  h1: {
    sizeMultiplier: 2.4,
    weight: 800,
    size: 32,
    lineHeight: 1.5,
    letterSpacing: -0.48,
  },
  h2: {
    sizeMultiplier: 2,
    weight: 700,
    size: 24,
    lineHeight: 1.5,
    letterSpacing: -0.48,
  },
  h3: {
    sizeMultiplier: 1.4,
    weight: 700,
    size: 20,
    lineHeight: 1.5,
    letterSpacing: -0.48,
  },
  h4: {
    sizeMultiplier: 1,
    weight: 700,
    size: 18,
    lineHeight: 1.5,
    letterSpacing: -0.48,
  },
  h5: {
    sizeMultiplier: 0.8,
    weight: 700,
    size: 16,
    lineHeight: 1.5,
    letterSpacing: -0.48,
  },
  p1: {
    sizeMultiplier: 1,
    weight: 400,
    size: 16,
    lineHeight: 1.5,
    letterSpacing: -0.48,
  },
  p2: {
    sizeMultiplier: 0.8,
    weight: 700,
    size: 14,
    lineHeight: 1.5,
    letterSpacing: -0.48,
  },
  p3: {
    sizeMultiplier: 0.65,
    weight: 400,
    size: 14,
    lineHeight: 1.5,
    letterSpacing: -0.48,
  },
  p4: {
    sizeMultiplier: 0.44,
    weight: 400,
    size: 12,
    lineHeight: 1.33,
    letterSpacing: -0.3,
  },
  p5: {
    sizeMultiplier: 0.44,
    weight: 400,
    size: 10,
    lineHeight: 1.5,
    letterSpacing: -0.48,
  },
  feedCommentOverlay: {
    weight: 400,
    size: 12.95,
    lineHeight: 1.2,
    letterSpacing: -0.03,
  },
}
